/** Client-side ceiling while waiting for parse/detection to finish (UI copy: "a few minutes"). */
export const FEC_IMPORT_ANALYSIS_TIMEOUT_MS = 10 * 60 * 1000
